module.exports = __webpack_public_path__ + "img/2f61c0200aabd5d21beedc800ae3df37.svg";